import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
// import { CanonicalService } from 'src/app/shared/canonical.service';
import { CanonicalService } from '../../shared/canonical.service';


@Component({
  selector: 'app-ios',
  templateUrl: './ios.component.html',
  styleUrls: ['./ios.component.css'],
})
export class IosComponent implements OnInit {

  heading = "Best iOS Mobile Device Security";
  subheading = "Your personal data is everywhere.";
  innerWidth:number = window.innerWidth;

  constructor(
    private titleService: Title,
     private metaTagService: Meta,
     private metaTagService1: Meta,
    private canonicalService: CanonicalService
     ) {
      this.canonicalService.setCanonicalURL("https://www.protectt.ai/mprotectt/ios");
     }

  ngOnInit(): void {
    // this.canonicalService.setCanonicalURL();
    setTimeout(() => {
      AOS.refresh();
    }, 500);
    this.titleService.setTitle('Mobile Security | IOS Security | Protectt.ai');
    this.metaTagService1.updateTag({name: 'title', content: 'Mobile App Security Protection for iOS Mobile Device | Protectt.ai'});
    this.metaTagService.addTags([
      { name: 'description', content: 'Enhanced Security for Foolproof iOS Devices. MProtectt for iphone offers 360degree protection - from malware attacks that breach your bank accounts to spyware that threatens your privacy.'},
      { name: 'keywords', content:'Best Mobile Privacy Guard for your iPhone. Get 360 degree security which protects Apps, Network attacks, Personal Photos, Information and many more.',},
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'mprotectt.protectt.ai' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'date', content: '01-06-2021', scheme: 'DD-MM-YYYY' },
      { charset: 'UTF-8' },
    ]);
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }
}
